// extracted by mini-css-extract-plugin
export default {"container":"SupplierValuation_container__Pnx6T"};